import { max, scaleLinear, ascending, quantile } from 'd3';
import Axis from '../Base/axis';
import Margin from '../Base/margin';
import Svg from '../Base/svg';
import { ChartCtrParams } from '../types';
import Utils from '../Utils';

export default class BoxPlot {
  elementId: string;
  element: Svg;
  dataRaw = [];
  height = 200;
  width = 300;
  margin: Margin;
  xAxis: Axis;
  yAxis: Axis;

  boxCenter = 200;
  boxWidth = 100;

  min: number;
  median: number;
  max: number;
  q1: number;
  q3: number;

  constructor(params?: ChartCtrParams) {
    if (params?.elementId) this.elementId = params.elementId;
    if (params?.data) this.dataRaw = params.data;
    if (params?.height) this.height = params.height;
    if (params?.width) this.width = params.width;

    this.margin = new Margin(params.margin);
    this.yAxis = new Axis({ loc: 'left' });
    this.xAxis = new Axis({ loc: 'bottom' });
    this.useAutoAxis();
    this.computeStats();
  }

  render() {
    const { elementId, height, width, margin } = this;
    this.element = new Svg({ elementId, height, width, margin });

    this.element.draw();
    this.drawYAxis();
    this.drawBox();
  }

  drawYAxis() {
    const { d3Svg } = this.element;
    const ax = Utils.drawAxis(d3Svg, this.yAxis);
  }

  drawBox() {
    const yscale = this.yAxis.scale;
    this.element.d3Svg.append('line').attr('x1', this.boxCenter).attr('x2', this.boxCenter).attr('y1', this.yAxis.scale(this.min)).attr('y2', this.yAxis.scale(this.max)).attr('stroke', 'black');

    this.element.d3Svg
      .append('rect')
      .attr('x', this.boxCenter - this.boxWidth / 2)
      .attr('y', this.yAxis.scale(this.q3))
      .attr('height', this.yAxis.scale(this.q1) - this.yAxis.scale(this.q3))
      .attr('width', this.boxWidth)
      .attr('stroke', 'black')
      .style('fill', 'steelblue');

    // show median, min and max horizontal lines
    this.element.d3Svg
      .selectAll('toto')
      .data([this.min, this.median, this.max])
      .enter()
      .append('line')
      .attr('x1', this.boxCenter - this.boxWidth / 2)
      .attr('x2', this.boxCenter + this.boxWidth / 2)
      .attr('y1', function (d) {
        return yscale(d);
      })
      .attr('y2', function (d) {
        return yscale(d);
      })
      .attr('stroke', 'black');
  }

  computeStats() {
    const data = this.dataRaw.sort(ascending);
    this.q1 = quantile(data, 0.25);
    this.median = quantile(data, 0.5);
    this.q3 = quantile(data, 0.75);

    const iqr = this.q3 - this.q1; // inter quantile range
    this.min = this.q1 - 1.5 * iqr;
    this.max = this.q1 + 1.5 * iqr;
  }

  useAutoAxis() {
    const { dataRaw, height, margin } = this;
    const h = height - margin.top - margin.bottom;

    const yMax = max(dataRaw);
    const yRange = [h, 0];
    const yDomain = [0, yMax];
    const yScale = scaleLinear().domain(yDomain).range(yRange);
    this.yAxis.setDomain(yDomain);
    this.yAxis.setScale(yScale);
  }
}
